import { useState } from 'react'
import Style from './upload.module.scss'
import { RcFile } from 'antd/lib/upload'
import { message, Upload } from 'antd'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { UPLOAD_FILES_NO_SAVE } from '@/api/orderManage'
import { QualityList } from '@/api/reportApi'

interface Props {
  dataSource: QualityList[]
  onChange?: (e: QualityList[]) => void
  // platformCode: string
  setUploadLoading?: (load: boolean) => void
}
// 上传文件
const Uploadimg = (props: Props) => {
  const [fileList, setFileList] = useState<any[]>()
  const {
    dataSource,
    onChange,
    // platformCode,
    setUploadLoading,
  } = props
  const handleRemove = (file: any) => {
    setFileList(fileList?.filter((item) => item.uid !== file.uid))
    const newData = dataSource.filter((i) => i.name !== file.name)
    onChange?.(newData)
  }
  const customRequest = async (file: RcFile[]) => {
    const addFile = file.map((item) => {
      return { ...item, name: item.name, status: 'uploading', percent: 10 }
    })
    setFileList((prevFileList) =>
      prevFileList ? [...prevFileList, ...addFile] : addFile,
    )
    setUploadLoading?.(true)
    try {
      const resData = await UPLOAD_FILES_NO_SAVE(
        { type: 'materialAptitude' },
        file,
      )
      if (resData.code === 0) {
        const list = resData.data
        message.success('上传成功')
        const arr = [...dataSource, ...list]
        onChange?.(arr)
        setFileList((prevFileList) =>
          prevFileList?.map((item) => {
            return { ...item, status: 'success', percent: 100 }
          }),
        )
        setUploadLoading?.(false)
      } else {
        message.error(`上传失败：${resData.msg}`)
        setFileList((prevFileList) =>
          prevFileList?.map((item) => {
            return { ...item, status: 'error', percent: 100 }
          }),
        )
        setUploadLoading?.(false)
      }
    } catch (error) {
      console.log('uploadimg -> error', error)
    }
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    const nameReg = /^[1-8].+\+.+$/
    const fileTypeReg = new RegExp(
      /^.*(\.doc|\.docx|\.pdf|\.xls|\.xlsx|\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.webp)$/i,
    )
    if (file.name.search(fileTypeReg) === -1) {
      message.error('上传失败：请上传正确的图片格式！')
      top = 0
      return false
    } else if (dataSource.some((i) => i.name === file.name)) {
      message.error('上传失败：图片重复')
      top = 0
      return false
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      customRequest(FileList)
      top = 0
    }
    return false
  }

  return (
    <div className={Style.fileimgbox}>
      <div className={Style.fileimglist}>
        <Upload
          accept={'.doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.webp'}
          multiple={true} // 是否多文件上传
          fileList={fileList}
          beforeUpload={beforeUpload}
          onRemove={handleRemove}
          className={Style.uploadQualityList}
        >
          <div className={Style.uploadBtn}>
            <CloudDownloadOutlined className={Style.uploadBtnIcon} />
            <span>
              文件拖放到此处，或
              <span style={{ color: '#FFBF6B' }}> 点击上传</span>
            </span>
          </div>
        </Upload>
      </div>
    </div>
  )
}

export default Uploadimg
import { useState } from 'react'
import Style from './upload.module.scss'
import { RcFile } from 'antd/lib/upload'
import { message, Upload } from 'antd'
import { CloudDownloadOutlined } from '@ant-design/icons'
import { UPLOAD_FILES_NO_SAVE } from '@/api/orderManage'
import { QualityList } from '@/api/reportApi'

interface Props {
  dataSource: QualityList[]
  onChange?: (e: QualityList[]) => void
  // platformCode: string
  setUploadLoading?: (load: boolean) => void
}
// 上传文件
const Uploadimg = (props: Props) => {
  const [fileList, setFileList] = useState<any[]>()
  const {
    dataSource,
    onChange,
    // platformCode,
    setUploadLoading,
  } = props
  const handleRemove = (file: any) => {
    setFileList(fileList?.filter((item) => item.uid !== file.uid))
    const newData = dataSource.filter((i) => i.name !== file.name)
    onChange?.(newData)
  }
  const customRequest = async (file: RcFile[]) => {
    const addFile = file.map((item) => {
      return { ...item, name: item.name, status: 'uploading', percent: 10 }
    })
    setFileList((prevFileList) =>
      prevFileList ? [...prevFileList, ...addFile] : addFile,
    )
    setUploadLoading?.(true)
    try {
      const resData = await UPLOAD_FILES_NO_SAVE(
        { type: 'materialAptitude' },
        file,
      )
      if (resData.code === 0) {
        const list = resData.data
        message.success('上传成功')
        const arr = [...dataSource, ...list]
        onChange?.(arr)
        setFileList((prevFileList) =>
          prevFileList?.map((item) => {
            return { ...item, status: 'success', percent: 100 }
          }),
        )
        setUploadLoading?.(false)
      } else {
        message.error(`上传失败：${resData.msg}`)
        setFileList((prevFileList) =>
          prevFileList?.map((item) => {
            return { ...item, status: 'error', percent: 100 }
          }),
        )
        setUploadLoading?.(false)
      }
    } catch (error) {
      console.log('uploadimg -> error', error)
    }
  }

  let top = 0
  // 上传之前处理图片
  const beforeUpload = (file: RcFile, FileList: RcFile[]) => {
    const nameReg = /^[1-8].+\+.+$/
    const fileTypeReg = new RegExp(
      /^.*(\.doc|\.docx|\.pdf|\.xls|\.xlsx|\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.webp)$/i,
    )
    if (file.name.search(fileTypeReg) === -1) {
      message.error('上传失败：请上传正确的图片格式！')
      top = 0
      return false
    } else if (dataSource.some((i) => i.name === file.name)) {
      message.error('上传失败：图片重复')
      top = 0
      return false
    }
    top++
    // 防止重复提交
    if (top === FileList.length) {
      customRequest(FileList)
      top = 0
    }
    return false
  }

  return (
    <div className={Style.fileimgbox}>
      <div className={Style.fileimglist}>
        <Upload
          accept={'.doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.webp'}
          multiple={true} // 是否多文件上传
          fileList={fileList}
          beforeUpload={beforeUpload}
          onRemove={handleRemove}
          className={Style.uploadQualityList}
        >
          <div className={Style.uploadBtn}>
            <CloudDownloadOutlined className={Style.uploadBtnIcon} />
            <span>
              文件拖放到此处，或
              <span style={{ color: '#FFBF6B' }}> 点击上传</span>
            </span>
          </div>
        </Upload>
      </div>
    </div>
  )
}

export default Uploadimg
